"use client";

import { Timer } from "iconsax-reactjs";
import type * as React from "react";
import { persianYearLabel } from "@/lib/stake/dao-year";
import { cn } from "@/lib/utils";

interface DaoYearChipsProps {
  currentYear: number;
}

/** Non-interactive DAO-year indicators: current year active (timer), completed years ✓. */
export const DaoYearChips: React.FC<DaoYearChipsProps> = ({ currentYear }) => {
  const years = Array.from({ length: currentYear }, (_, i) => i + 1);
  return (
    <div className="flex flex-row flex-wrap justify-center gap-2">
      {/* RTL source order: year 1 first (rightmost) */}
      {years.map((year) => {
        const isCurrent = year === currentYear;
        return (
          <span
            key={year}
            className={cn(
              "flex items-center gap-1 rounded-full h-8 px-4 text-xs font-medium",
              isCurrent
                ? "bg-accent text-text-button-label"
                : "bg-bg-tertiary text-text-primary",
            )}
          >
            {persianYearLabel(year)}
            {isCurrent ? (
              <Timer size={14} />
            ) : (
              <span aria-hidden="true">✓</span>
            )}
          </span>
        );
      })}
    </div>
  );
};
